<template>
  <div class="vx-row">
    <div class="w-full vx-col" v-can="'view-otif-target-setting'">
      <vx-card :title="'OTIF TARGETS (%)'" class="">
        <div id="otif-target-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe class="mt-8" noDataText="">
              <template slot="thead">
                <vs-th width="25%"></vs-th>
                <vs-th v-for="(country_type) in country_types" :key="country_type" width="25%">
                  <span style="text-transform: uppercase !important;">{{ country_type }}</span>
                </vs-th>
              </template>

              <template slot-scope="{data}">
                <!-- Product type rows -->
                <vs-tr v-for="(fg_type, index) in fg_types" :key="'row-' + index">
                  <vs-th><span style="text-transform: uppercase !important;">{{ fg_type }}</span></vs-th>
                  <vs-td v-for="(country_type, cIndex) in country_types" :key="'col-' + cIndex">
                    <div class="flex items-center">
                      <span class="mr-4 font-semibold" style="min-width: 45px;">
                        {{ generateOtifTarget(fg_type, country_type) }}
                      </span>
                      <vx-tooltip :text="`Add/Update target`" position="left" v-can="'edit-otif-target-setting'">
                        <vs-button size="small" icon-pack="feather"
                          @click.stop="onClickAddUpdateTarget(fg_type, country_type)"
                          :color="!!generateOtifTarget(fg_type, country_type) ? 'warning' : 'primary'"
                          :icon="!!generateOtifTarget(fg_type, country_type) ? 'icon-edit' : 'icon-plus'"
                          type="border"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left" v-if="!!generateOtifTarget(fg_type, country_type)"
                        v-can="'edit-otif-target-setting'">
                        <vs-button @click.stop="openConfirm(fg_type, country_type)" class="ml-3" size="small"
                          color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>

                <!-- Bottom Total Row for Region Columns -->
                <vs-tr class="total-row font-bold border-t">
                  <vs-th>
                    <span class="badge-total">TOTAL</span>
                  </vs-th>
                  <vs-td v-for="(country_type, cIndex) in country_types" :key="'total-col-' + cIndex">
                    <span class="font-bold text-primary text-base">
                      {{ calculateRegionTotal(country_type) }}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <add-new-otif-target-pop-up ref="addNewOtifTargetPopUp" />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewOtifTargetPopUp from '@/components/popups/settings/otif-target/AddNewOtifTargetPopUp.vue';

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const OtifTargetRepository = RepositoryFactory.get('otif_target');

export default {
  name: "OtifTargetSettings",
  data() {
    return {
      otif_target_list: [],
      fg_types: ['powder', 'liquid', 'spray dry powder', 'fruit'],
      country_types: ['Great Britain', 'Europe', 'ROW']
    }
  },
  components: {
    AddNewOtifTargetPopUp
  },
  methods: {
    async refreshData() {
      await this.fetchOtifTargetList()
    },
    async fetchOtifTargetList() {
      await this.$vs.loading({
        container: '#otif-target-list-table',
        scale: 0.45
      })
      try {
        const response = await OtifTargetRepository.getOtifTargets()
        const rawData = response.data
        if (Array.isArray(rawData)) {
          this.otif_target_list = rawData
        } else if (rawData && Array.isArray(rawData.data)) {
          this.otif_target_list = rawData.data
        } else if (rawData && rawData.data && Array.isArray(rawData.data.data)) {
          this.otif_target_list = rawData.data.data
        } else {
          this.otif_target_list = []
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.$vs.loading.close('#otif-target-list-table > .con-vs-loading')
      }
    },
    getOtifTargetObj(fg_type, country_type) {
      return this.otif_target_list.find((x) => {
        return x.formulation_type &&
          x.formulation_type.toLowerCase() === fg_type.toLowerCase() &&
          x.region &&
          x.region.toLowerCase() === country_type.toLowerCase()
      })
    },
    generateOtifTarget(fg_type, country_type) {
      const find = this.getOtifTargetObj(fg_type, country_type)
      return (find && find.target !== undefined && find.target !== null) ? `${find.target}%` : null
    },
    calculateRegionTotal(country_type) {
      const targets = []
      this.fg_types.forEach(fg_type => {
        const find = this.getOtifTargetObj(fg_type, country_type)
        if (find && find.target !== undefined && find.target !== null && !isNaN(Number(find.target))) {
          targets.push(Number(find.target))
        }
      })
      if (targets.length === 0) return '-'
      const sum = targets.reduce((acc, curr) => acc + curr, 0)
      const avg = Math.round(sum / targets.length)
      return `${avg}%`
    },
    openConfirm(fg_type, country_type) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [fg_type, country_type]
      })
    },
    async onClickDelete(params) {
      try {
        const find = this.getOtifTargetObj(params[0], params[1])
        if (find && find.id) {
          await OtifTargetRepository.deleteOtifTarget(find.id)
          await this.fetchOtifTargetList()
          await this.showSuccessMessage('OTIF target deleted!');
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickAddUpdateTarget(fg_type, country_type) {
      const find = this.getOtifTargetObj(fg_type, country_type)
      if (find && find.id) {
        await this.$refs.addNewOtifTargetPopUp.openPopup(find.id, fg_type, country_type, find.target)
      } else {
        await this.$refs.addNewOtifTargetPopUp.openPopup(null, fg_type, country_type)
      }
    },
  },
  async mounted() {
    await this.fetchOtifTargetList()
  },
  mixins: [Filter, SuccessMessage, ErrorMessages]
}
</script>

<style scoped>
.total-row {
  background-color: rgba(var(--vs-primary), 0.04);
}

.badge-total {
  background-color: rgba(var(--vs-primary), 0.15);
  color: rgba(var(--vs-primary), 1);
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  display: inline-block;
  text-transform: uppercase;
}
</style>
